module.exports = __webpack_public_path__ + "img/img5-6.e275ab9d.png";